import React from "react";
import "./PageFooter.css";
import { getTechLogoUrl, getCustomElementUrl } from "../../utils/cloudinary";

// Cloudinary URLs for images
const LinkedInLogo = getTechLogoUrl('linkedin_logo');
const GithubLogo = getTechLogoUrl('github_logo');
const copyright_symbol = getCustomElementUrl('copyright');

const PageFooter = () => {
    const scrollToTop = () => {
        console.log("scrollToTop");
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <footer className="page-footer">
            <div className="footer-content">
                <div className="footer-logo" onClick={scrollToTop}>
                    JMNB
                </div>
                <div className="footer-connect">
                    <p className="footer-connect-text">CONNECT WITH ME</p>
                    <div className="social-icons-footer">
                        <div className="github-and-linkedin-icons-footer">
                            <a
                                href="https://www.linkedin.com/in/jens-martin-norheim-berget-87560b141/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src={LinkedInLogo}
                                    alt="LinkedIn"
                                    className="linkedin-and-github-icon-footer"
                                />
                            </a>
                        </div>
                        <div className="github-and-linkedin-icons-footer">
                            <a
                                href="https://github.com/jmnorheim"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src={GithubLogo}
                                    alt="GitHub"
                                    className="linkedin-and-github-icon-footer"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            <div className="footer-rights">
                <img
                    src={copyright_symbol}
                    alt="copyright"
                    className="copyright-symbol"
                />
                Jens Martin Norheim Berget
            </div>
        </footer>
    );
};

export default PageFooter;
